import { render, staticRenderFns } from "./Love.vue?vue&type=template&id=553b5aa8&scoped=true"
import script from "./Love.js?vue&type=script&lang=js&external"
export * from "./Love.js?vue&type=script&lang=js&external"
import style0 from "./Love.scss?vue&type=style&index=0&id=553b5aa8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b5aa8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HotLoveTabs: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/LoveTabs/LoveTabs.vue').default})
